import { buildQuote } from "./utils.js";
/** Price ICPAK Private Motor. */
export function priceMotor(input, rates) {
    const items = [];
    let basicPremium = 0;
    if (input.coverType === "COMPREHENSIVE") {
        const value = input.vehicleValueKes ?? 0;
        const band = rates.comprehensive.valueBands.find((b) => value <= b.maxValueKes);
        const pct = band?.ratePct ?? rates.comprehensive.valueBands.at(-1).ratePct;
        basicPremium = Math.max(rates.comprehensive.minimumBasicPremiumKes, value * pct);
    }
    else {
        basicPremium = rates.thirdParty.flatPremiumKes;
    }
    items.push({
        code: "BASIC_PREMIUM",
        label: "Basic Premium",
        amountKes: basicPremium,
    });
    if (input.coverType === "COMPREHENSIVE") {
        const ext = input.extensions;
        const included = rates.comprehensive.extensionsIncludedInBasic;
        const fees = rates.comprehensive.extensionFlatFeesKes;
        if (ext.excessProtector) {
            const isIncluded = included.includes("EXCESS_PROTECTOR");
            items.push({
                code: "EXCESS_PROTECTOR",
                label: "Excess Protector",
                amountKes: isIncluded ? 0 : fees.EXCESS_PROTECTOR ?? 0,
                note: isIncluded ? "Included in Basic Premium" : undefined,
            });
        }
        if (ext.politicalViolenceAndTerrorism) {
            const isIncluded = included.includes("POLITICAL_VIOLENCE_TERRORISM");
            items.push({
                code: "POLITICAL_VIOLENCE_TERRORISM",
                label: "Political Violence & Terrorism Cover",
                amountKes: isIncluded ? 0 : fees.POLITICAL_VIOLENCE_TERRORISM ?? 0,
                note: isIncluded ? "Included in Basic Premium" : undefined,
            });
        }
        if (ext.aaRoadRescue) {
            items.push({
                code: "AA_ROAD_RESCUE",
                label: "AA of Kenya Road Rescue (within 40km radius)",
                amountKes: fees.AA_ROAD_RESCUE ?? 0,
            });
        }
        if (ext.personalAccident) {
            items.push({
                code: "PERSONAL_ACCIDENT",
                label: "Personal Accident Cover for Insured/Authorized Driver (KES 1,000,000)",
                amountKes: fees.PERSONAL_ACCIDENT ?? 0,
            });
        }
        if (ext.courtesyCar) {
            items.push({
                code: "COURTESY_CAR_10_DAYS",
                label: "Courtesy Car / Loss of Use for 10 days (excluding the first 72 hours)",
                amountKes: fees.COURTESY_CAR_10_DAYS ?? 0,
            });
        }
    }
    const subtotal = items.reduce((a, b) => a + b.amountKes, 0);
    const levies = subtotal *
        (rates.levies.trainingLevyPct + rates.levies.policyHolderFundPct);
    return buildQuote({
        product: "motor_private",
        ratesVersion: rates.version,
        items,
        leviesKes: levies,
        stampDutyKes: rates.stampDutyKes,
    });
}
